import Splide from '@splidejs/splide';

const hero = document.querySelector('.hero');
const heroSlider = document.querySelector('.hero .hero__slider');

// hero slider
if( hero && heroSlider ) {
    var splide = new Splide( '.hero__slider' , {
        type: 'fade',
        rewind: true,
        speed: 4000,
        interval: 7000,
        autoplay: true,
        arrows: false,
        pagination: false,
        perPage: 1,
        perMove: 1
    });
    splide.mount();
}

// Function to set video source based on viewport width
function setVideoSource() {
    const videoElement = document.getElementById('heroVideo');

    if( videoElement ){
        const sourceElement = videoElement.querySelector('source');

        const desktopVideoSrc = videoElement.getAttribute('data-desktop-video');
        const destopVideoPosterSrc = videoElement.getAttribute('data-desktop-poster');
        const mobileVideoSrc = videoElement.getAttribute('data-mobile-video');
        const mobileVideoPosterSrc = videoElement.getAttribute('data-mobile-poster');

        const isMobile = window.innerWidth < 768;

        // Set the appropriate video source
        if( desktopVideoSrc !== null && !isMobile ){
            sourceElement.src = desktopVideoSrc;
        }

        if( isMobile ){
            if( mobileVideoSrc !== null ){
                sourceElement.src = mobileVideoSrc;
            }else{
                sourceElement.src = desktopVideoSrc;
            }
        }

        videoElement.poster = "";
        if( destopVideoPosterSrc !== null && !isMobile ){
            videoElement.poster = destopVideoPosterSrc;
        }

        if( mobileVideoPosterSrc !== null && isMobile ){
            videoElement.poster = mobileVideoPosterSrc;    
        }

        // Reload the video to apply the new source
        videoElement.load();
    }
}

// Set initial video source on page load
window.addEventListener( 'load', setVideoSource);